/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import './store';
import '@/views_v2/home/store';
import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import { RouterV2Enum } from '@/router/router-names';

import Profile from '@/packages/profile';
import HomeBottomBar from '@/components/home-bottom-bar';

import isPrerendering from '@/shared/utils/isPrerendering';
import platform from '@/shared/utils/platform';
import NavBar from '@/components/nav-bar';
import type { Route } from 'vue-router/types/router';
import { listerBack } from '@/shared/utils/backListener';
import { changeTabbarShowStatus, getSkTabInfo, skNativeContainer } from '@/api/native/container';
import { ubtPage } from '@/shared/utils/ubt';
import store from '@/store';
import { dispatchActions } from '@/store/dispatchActions';
import { PageThemeTypeEnum } from '@/enums/pageThemeType';
import { PageSourceEnum } from '@/api/common/types';
import FinanceCard from './components/finance-card/index.vue';
import WelfareCenter from './components/welfare-center';
import ToolList from './components/tool-list';
import RiskStatement from '../home/components/risk-statement';
import SwipeBannerNew from './components/swipe-banner-new';
import SuperMember from './components/super-member/index.vue';
import AdvMyProfileBanner from '../../components/adv-components/adv-my-profile-banner';
import ShopMallEntrance from './components/shop-mall-entrance/index.vue';

import style from './index.module.scss';
import './theme.orange.scss';
import './theme.blue.scss';

const BaseStore = namespace('base');
const HomeStore = namespace('home');
const _isPrerendering = isPrerendering();

@Component
export default class MyProfile extends Vue {
  @BaseStore.State pageThemeType!: PageThemeTypeEnum;

  @HomeStore.Action getCreditData!: () => Promise<void>;

  @HomeStore.Action getAliProductStatus!: () => Promise<void>;

  private get showH5NavBar() {
    return !_isPrerendering && (platform.isEasyBike || platform.isSkzhenxhApp);
  }

  private backgroundColor = 'transparent';

  private routeInstance: Route | undefined;

  /** 是否展示非内部的广告，小程序、钉钉不展示 */
  private showNonInternalAdv = !(platform.isAlipayMini
    || platform.isDingTalk
    || platform.isWechatMini);

  private async createdFunc() {
    if (!_isPrerendering) {
      /** 页面内部埋点 */
      if (this.$route?.meta.ubtPageViewCustom) {
        const now = new Date().getTime();
        // 判断这个用户是否有当期或者逾期的账单需要还款，用于计算还款转化率
        ubtPage(this.$route?.meta.pageId, '', now, undefined, {});
      }
      await Promise.all([
        this.getCreditData(),
        dispatchActions.userAutarkyStatus.getUserAutarkyState(),
        dispatchActions.base.getBusinessInfoExtra({ pageSource: PageSourceEnum.MY_PROFILE }),
        dispatchActions.base.getIsWebviewSkNativeContainer(),
      ]);

      if (platform.isAlipayMini || platform.isDingTalk) {
        await this.getAliProductStatus();
      }
    }
  }

  private async created() {
    const { haveShown } = await getSkTabInfo('my');

    if (await skNativeContainer()) {
      /**  容器内 true的时候 才去调用接口，上报埋点 */
      if (haveShown) {
        this.createdFunc();
      }
    } else {
      /** 非容器内，正常请求 */
      this.createdFunc();
    }


    this.routeInstance = this.$route;
  }

  /** 组件销毁时移除监听，回退navBar设置，以解决跳转新项目,导航栏的相关问题 */
  private beforeDestroy() {
    // 离开我的页面，移除监听
    document.removeEventListener('scroll', this.handleScrollBind);
    // 回退设置，以解决切换导航栏BUG
    if (this.routeInstance) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.routeInstance.meta.navBarCustomProps.background = 'transparent';
    }

    this.backgroundColor = 'transparent';
  }

  private ticking = false;

  private lastKnownScrollPosition = 0;

  /** 滚动事件处理，用来实现沉浸式导航栏 */
  private listenScroll() {
    this.lastKnownScrollPosition = window.scrollY;

    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        if (this.lastKnownScrollPosition > 0) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          this.$route.meta.navBarCustomProps.background = '#fff';
          this.backgroundColor = '#fff';
        } else {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          this.$route.meta.navBarCustomProps.background = 'transparent';
          this.backgroundColor = 'transparent';
        }
        this.ticking = false;
      });

      this.ticking = true;
    }
  }

  private handleScrollBind = this.listenScroll.bind(this);

  private async mounted() {
    if (_isPrerendering) {
      document.dispatchEvent(new Event('render-event'));
    }

    document.addEventListener('scroll', this.handleScrollBind, { passive: true });

    if (await skNativeContainer()) {
      /** 不能自动取消 需要持续监听 */
      /** 监听app容器切换 */
      listerBack(async () => {
        const { haveShown } = await getSkTabInfo('my');

        /** 在首页 我的页面 才显示tabbar */
        if (this.$route.path === RouterV2Enum.myProfile && haveShown) {
          /** 回到我的页 展示 tabbar */
          changeTabbarShowStatus(true);
          this.createdFunc();
        }
      }, false);
    }
  }

  private render() {
    return (
      <div
        class={[
          style.pageContainer,
          store.state.base.isHybridAppMode && style.hybridAppMode,
        ]}
        id="myProfile"
      >
        {/** 为了实现沉浸式导航栏封装 */}
        <div class={[
          style.wrapper,
          this.showH5NavBar && style.wrapperPadding,
          this.showH5NavBar && platform.isAndroid && style.wrapperAndroidPadding,
        ]}>
          <NavBar
            show={true}
            textAlign='center'
            background={this.backgroundColor}
            statusBarBackground='white'
            isShowStatusBar={false}
            isDarkStatusBar={true}
            key={this.backgroundColor}
          ></NavBar>
          <div class={style.bg}></div>
          <div class={style.mainContent}>
            <Profile onClick={this.goSetting.bind(this)} />

            {(!_isPrerendering && !platform.isWechatMini) && <SuperMember />}

            {!_isPrerendering && <FinanceCard />}

            {!_isPrerendering && ([
              <ShopMallEntrance />,
              this.showNonInternalAdv && <WelfareCenter />,
              this.showNonInternalAdv && <SwipeBannerNew />,
              this.showNonInternalAdv && <AdvMyProfileBanner />,
              <ToolList />,
              <RiskStatement sence={false} />,
            ])}

          </div>
        </div>
        {/** 底部tabbar */}
        {!_isPrerendering && <HomeBottomBar /> }
      </div>
    );
  }

  private goSetting() {
    this.$router.push({
      path: RouterV2Enum.setting,
    });
  }
}
